<template>
  <pbc-modal ref='modal' @close="close" :disable-title="true">
    <template #default="{}">
      <div class="flex flex-col h-full overflow-hidden">
        <div class="m-auto text-grey-700 text-sm font-semibold bg-white w-full">Add New</div>
        <add-component-wizard v-for='(addingToParent,i) in addingToParents' ref='addComponentWizard'
          :key='addingToParent.id'
          :component='addingToParent'
          :transform='addingToTransforms[i]'
          :partutil='partutil'
          :transforms-and-source='transformsAndSource'
          :links='links'
          :components='components'
          :autolink='autolink'
          @next='next'
          @validate-step='onValidateStep'
          @change-step='changeStep'
          @add-components='$emit("add-components", $event)'
          @add-recommendation='$emit("add-link-recommendation", $event)'
          />
      </div>
    </template>
    <template #controls="{}">
      <div class="mx-2 mb-2 pt-2 flex justify-center border-t border-solid border-grey-500">
        <pbc-button @click="close">
          <close class="mx-2"/>
          <span class="mr-2">Cancel</span>
        </pbc-button>
        <pbc-button :disabled='currentStep !== numSteps - 1' @click="preview">
          <play class="mx-1"/>
          <span class="mr-2">Preview</span>
        </pbc-button>
        <pbc-button v-if='currentStep < (numSteps - 1)' :disabled='!nextEnabled' @click="next" class="bg-blue-400" :class='nextEnabled ? "animate-next" : ""'>
          <chevron-right class="mx-1"/>
          <span class="mr-2">Next</span>
        </pbc-button>
        <pbc-button v-if='currentStep === numSteps - 1' class="bg-blue-400 animate-next" @click="done">
          <check class="mx-1"/>
          <span class="mr-2">Done</span>
        </pbc-button>
      </div>
    </template>
  </pbc-modal>
  
</template>
<script>
import AddComponentWizard from './AddComponentWizard.vue';
import Check from '@icons/Check.vue';
import Close from '@icons/Close.vue';
import Play from '@icons/Play.vue';
import ChevronRight from '@icons/ChevronRight.vue';

export default {
   props: {
    addingToParents: {
      type: Array,
      required: true
    },
    addingToTransforms: {
      type: Array,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    links: {
      type: Array,
      required: true
    },
    components: {
      type: Array,
      required: true
    },
     autolink: {
       type: Object,
       default() {
         return {};
       }
     }
  },
  data() {
    return {
      currentStep: 0,
      nextEnabled: false,
      numSteps: 0
    }
  },
  components: {
    AddComponentWizard,
    Check,
    Close,
    Play,
    ChevronRight
  },
  methods: {
    onValidateStep(nv) {
      this.nextEnabled = nv;
    },
    next() {
      if (this.currentStep == this.numSteps - 1) {
        this.done();
      } else {
        this.$refs.addComponentWizard.forEach( (acw) => {
          acw.next(this.currentStep + 1);
        });
      }
      //this.$refs.addTransformWizard.selectStep(this.currentStep + 1);
    },
    done() {
      this.$refs.addComponentWizard.forEach( (acw) => {
        acw.done();

        this.$ana.track({
          eventCategory: 'place',
          eventAction: 'saveComponent',
          extra: {
            parent: acw.component.type,
            child: acw.addedComponent.type
          }
        });
      });

      this.$refs.modal.close(true);
      this.$emit("close");
    },
    close() {
      this.$refs.addComponentWizard.forEach( (acw) => {
        acw.undo();
      });
      this.$refs.modal.close(true);
      this.$emit("close");
    },
    preview() {
      this.$emit("preview");
    },
    changeStep(newStep, numSteps) {
      this.currentStep = newStep;
      this.numSteps = numSteps;
    },
  }

}
</script>
